import cn from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/primitives/Button';
import { Icon, Layer } from '@/primitives/Icons';

import styles from './MaterialDropdown.module.css';

export const MaterialDropdown = ({
  onAddSheetGroup,
  onAddBeamGroup,
  hasMaterials,
}: {
  onAddSheetGroup: () => void;
  onAddBeamGroup: () => void;
  hasMaterials: boolean;
}) => {
  const addMenuRef = useRef<HTMLDivElement>(null);
  const [showMenu, setShowMenu] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    if (!showMenu) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (
        addMenuRef.current &&
        !addMenuRef.current.contains(event.target as Node)
      ) {
        setShowMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu, setShowMenu]);

  return (
    <div
      ref={addMenuRef}
      style={{ position: 'relative', display: 'inline-block' }}
      className={styles.materialDropdown}
    >
      <Button
        disabled={!hasMaterials}
        name="add-material"
        icon={<Icon icon={<Layer />} />}
        variant="secondaryPill"
        onClick={() => setShowMenu((v) => !v)}
      >
        {t('cutlist-form.cta.addGroup')}
        <div
          className={cn(styles.ggChevronDown, showMenu && styles.ggChevronUp)}
        />
      </Button>
      {showMenu && (
        <div className={styles.menuContent}>
          <div
            className={styles.option}
            onClick={() => {
              onAddSheetGroup();
              setShowMenu(false);
            }}
          >
            {t('cutlist-form.sheetMaterial')}
          </div>
          <div
            className={styles.option}
            onClick={() => {
              onAddBeamGroup();
              setShowMenu(false);
            }}
          >
            {t('cutlist-form.beams')}
          </div>
        </div>
      )}
    </div>
  );
};
